import React from 'react';
import styled from 'styled-components';
import * as Text from '@commoncomponents/frontend-components/dist/components/Text';
import { colors } from '@commoncomponents/frontend-components/dist/styled';
const InfoBox = ({ header, text }) => (React.createElement(Wrapper, { className: "info-box" },
    React.createElement(Text.Caption1, { color: colors.rockyGrey, className: "weight-bold" }, header),
    React.createElement(Text.Caption1, { color: colors.rockyGrey }, text)));
const Wrapper = styled.div `
  background-color: ${colors.rousingPearl};
  padding: 16px 24px;
  width: 100%;

  @media (max-width: 768px) {
    background-color: ${colors.snowy};
    padding: 12px 16px;
  }
`;
export default InfoBox;
